import PropTypes from "prop-types";

const Porch = ({ fill }) => (
  <svg
    id="Porch-1"
    width="30px"
    height="30px"
    viewBox="0 0 23 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Shape Copy 7</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Safe-place---Mobile---Dark---1"
        transform="translate(-95.000000, -385.000000)"
        fill={fill}
        fillRule="nonzero"
      >
        <path
          d="M116.466667,406.560703 L116.466667,405.667969 C116.466667,404.674941 115.825682,403.828266 114.933333,403.513828 L114.933333,387.285156 C114.933333,386.025121 113.901553,385 112.633333,385 L100.366667,385 C99.0984467,385 98.0666667,386.025121 98.0666667,387.285156 L98.0666667,403.513828 C97.1743178,403.828266 96.5333333,404.674941 96.5333333,405.667969 L96.5333333,406.560703 C95.6409844,406.875141 95,407.721816 95,408.714844 L95,410.238281 C95,410.658953 95.3432622,411 95.7666667,411 C96.7173844,411 116.290384,411 117.233333,411 C117.656738,411 118,410.658953 118,410.238281 L118,408.714844 C118,407.721816 117.359016,406.875141 116.466667,406.560703 Z M99.2592593,387.477309 C99.2592593,387.067081 99.5989399,386.733333 100.016461,386.733333 L112.131687,386.733333 C112.549208,386.733333 112.888889,387.067081 112.888889,387.477309 L112.888889,403.2 L111.374486,403.2 L111.374486,388.965261 C111.374486,388.554388 111.035461,388.221285 110.617284,388.221285 L101.530864,388.221285 C101.112687,388.221285 100.773663,388.554388 100.773663,388.965261 L100.773663,403.2 L99.2592593,403.2 L99.2592593,387.477309 Z M109.566667,398.509804 L110.333333,398.509804 L110.333333,403.2 L102.666667,403.2 L102.666667,389.333333 L110.333333,389.333333 L110.333333,396.980392 L109.566667,396.980392 C109.143262,396.980392 108.8,397.322776 108.8,397.745098 C108.8,398.16742 109.143262,398.509804 109.566667,398.509804 Z M101.858896,409.266667 L96.7037037,409.266667 L96.7037037,408.4 C96.7037037,407.92212 97.0660696,407.533333 97.5114744,407.533333 L102.666667,407.533333 L101.858896,409.266667 Z M97.5555556,406.666667 L97.5555556,405.8 C97.5555556,405.32212 97.9179215,404.933333 98.3633262,404.933333 L103.518519,404.933333 L102.710748,406.666667 L97.5555556,406.666667 Z M102.666667,409.266667 L104.999442,404.933333 L107.148706,404.933333 L109.481481,409.266667 L102.666667,409.266667 Z M109.481481,404.933333 L114.636674,404.933333 C115.082079,404.933333 115.444444,405.32212 115.444444,405.8 L115.444444,406.666667 L110.289252,406.666667 L109.481481,404.933333 Z M116.296296,409.266667 L111.141104,409.266667 L110.333333,407.533333 L115.488526,407.533333 C115.93393,407.533333 116.296296,407.92212 116.296296,408.4 L116.296296,409.266667 Z"
          id="Shape-Copy-7"
        />
      </g>
    </g>
  </svg>
);

Porch.defaultProps = {
  fill: "#C3C3C3",
};

Porch.propTypes = {
  fill: PropTypes.string,
};

export default Porch;
